import L from 'leaflet'
import markerIcon from '../../../assets/images/icons/map-icon.svg'

import url from '@/utils/url'
import { TREADS_POLY_SUBCOLOR } from '@/config/map'
import { STATUSES } from '@/config/config'
import year from '@/utils/year'
import {
  atu,
  map as mapEndpoints,
  threads as threadsApi,
} from '@/api/api-endpoints'
import { OBJECT } from '@/utils/map/types'
import mapMixin from '@/mixins/map-mixin'
import FkkoMixin from '@/mixins/fkko-mixin'
import RegopMixin from '@/mixins/regop-mixin'
import RouteMixin from '@/mixins/route-mixin'
import { COLORS } from '@/utils'
import { REGION_CONFIG } from '@/config/regions'
import ObjectDrawer from '../utils/ObjectDrawer'

const mapConfig = REGION_CONFIG.map

const MARKER_ICON = L.icon({
  iconUrl: markerIcon,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
})

export default {
  mixins: [mapMixin, FkkoMixin, RouteMixin, RegopMixin],
  data() {
    this.map = null
    this.objectDrawer = null
    return {
      popup_tariff: null,
      showObjectsAll: false,
      showThreadsAll: false,
      allowThreadTypes: [],
      ignoreTKOLine: false,
      ignoreOtherLine: false,
      ignoreMixedLine: false,
      showModelTariffs: false,
      dateTkoStarts: [],
      dateTkoEnds: [],
      initialTkoObjects: {},
      currentTkoObjects: {},
      ignoreStatuses: [
        ...STATUSES.map((item) => {
          return { ...item, isIgnore: false }
        }),
      ],
      settlementBorder: null,
      sourceLayer: null,
      object_date_finish: null,
      object_date_start: null,
    }
  },
  watch: {
    $route: 'routeHandler',
    mapTkoObjects: 'setObjectStartYears',
    threads: 'setThreadsYears',
    ignoreStatuses() {
      this.$forceUpdate()
    },
  },
  computed: {
    mapBorders() {
      return this.$store.getters.readUrlEndpoint(
        mapEndpoints.heatMapRegOperators(
          this.$route.query.zoom || mapConfig.zoom
        )
      )
    },
    defaultZoom() {
      return REGION_CONFIG.map.zoom - 1
    },
    defaultTkoZoom() {
      return 10
    },
    mapBringTo() {
      return this.$store.getters.mapBringTo
    },
    updateMapStatus() {
      return this.$store.getters.updateMapStatus
    },
    contextmenu() {
      return true
    },
    contextmenuOpened() {
      return false
    },
    mapTariffs() {
      return this.$store.getters.readUrlEndpoint(
        this.getMapModelingRegionTariff()
      )
    },
    threadsRawData() {
      let ep = this.getThreadEndpoint(this.$route)
      return this.$store.getters.readUrlEndpoint(ep)
    },
    threads() {
      return (
        this.$store.getters.readUrlEndpoint(
          this.getThreadEndpoint(this.$route)
        ) || []
      )
    },
    heatMapFormedDistrict() {
      return this.$store.getters.readUrlEndpoint(
        mapEndpoints.heatMapRegOperators(
          this.$route.query.zoom || mapConfig.zoom
        )
      )
    },
    settlementsById() {
      let tmp = {}
      let settlements = this.settlements
      for (const set of settlements) {
        tmp[set.id] = set
      }
      return tmp
    },
    settlementsData() {
      return this.$store.getters.readUrlEndpoint(
        this.getSettlementEndpoint(this.$route, {})
      )
    },
    settlements() {
      if (!this.settlementsData?.length) {
        return []
      }

      return this.settlementsData.map((set) => {
        let showAfterZoom = this.defineShowAfterZoom(set)

        return { ...set, showAfterZoom, type: OBJECT.CITY }
      })
    },
    mapTkoObjectsById() {
      let tmp = {}
      let mapTkoObjects = this.mapTkoObjects
      for (let key in mapTkoObjects) {
        for (const v of mapTkoObjects[key]) {
          let hasStatus = false
          STATUSES.forEach((status) => {
            if (this.ignoreStatuses[status.slug] && v.status_id === status.id) {
              hasStatus = true
            }
          })

          if (hasStatus) {
            continue
          }

          tmp[v.id] = Object.assign(tmp[v.id] || {}, v)
          tmp[v.id].type = OBJECT.TKO
          // TODO: default zoom
          tmp[v.id].showAfterZoom = 1
        }
      }
      return tmp
    },
    // TODO: return as array
    mapTkoObjects() {
      return this.$store.getters.readUrlEndpoint(
        this.getMapTkoObjectsEndpoint(this.$route)
      )
    },
    garbageSourceData() {
      return this.$store.getters.readUrlEndpoint(
        this.getGarbageSourceEndpoint(this.$route, {})
      )
    },
    unauthorizedTkos() {
      let unauthorizedTkos = this.unauthorizedTkosData
      let tmp = []
      for (let key in unauthorizedTkos) {
        let unauthorizedTko = unauthorizedTkos[key]
        let showAfterZoom = this.defaultZoom

        tmp.push(
          Object.assign({}, unauthorizedTko, {
            showAfterZoom: showAfterZoom,
            type: OBJECT.UNAUTHORIZED_TKO,
          })
        )
      }
      return tmp
    },
    unauthorizedHeaps() {
      let unauthorizedHeaps = this.unauthorizedHeapsData
      let tmp = []
      for (let key in unauthorizedHeaps) {
        let unauthorizedHeap = unauthorizedHeaps[key]
        let showAfterZoom = this.defaultZoom

        tmp.push(
          Object.assign({}, unauthorizedHeap, {
            showAfterZoom: showAfterZoom,
            type: OBJECT.OFFLINE,
          })
        )
      }
      return tmp
    },
    msnContainers() {
      let msnContainers = this.msnData
      let tmp = []
      for (let key in msnContainers) {
        let msnContainer = msnContainers[key]
        let showAfterZoom = this.defaultZoom

        tmp.push(
          Object.assign({}, msnContainer, {
            showAfterZoom,
            type: OBJECT.OFFLINE,
          })
        )
      }
      return tmp
    },
    unauthorizedTkosData() {
      return this.$store.getters.readUrlEndpoint(
        this.getUnauthorizedTkosEndpoint(this.$route, {})
      )
    },
    unauthorizedHeapsData() {
      return this.$store.getters.readUrlEndpoint(
        this.getUnauthorizedHeapsEndpoint(this.$route, {})
      )
    },
    msnData() {
      return this.$store.getters.readUrlEndpoint(
        this.getMSNContainersEndpoint(this.$route, {})
      )
    },
    garbageSources() {
      if (!this.garbageSourceData?.length) {
        return []
      }
      let showAfterZoom = this.defaultZoom
      return this.garbageSourceData.map((garbageSource) => ({
        ...garbageSource,
        showAfterZoom,
        type: OBJECT.GARBAGE,
      }))
    },
    garbageSourcesById() {
      let tmp = {}
      let garbageSources = this.garbageSources
      for (const garbageSource of garbageSources) {
        tmp[garbageSource.id] = garbageSource
      }
      return tmp
    },
    relations() {
      let threads = this?.threads?.data ? Object.values(this.threads?.data) : []
      if (!threads?.length) {
        return []
      }
      const nodes = []
      const tkoMinZoom = {}
      let threadData = this.$store.getters.readUrlEndpoint(
        threadsApi.constants()
      )?.pointTypesColors
      let colorArr = []
      this.allowThreadTypes.forEach((el) => {
        colorArr.push(threadData[el])
      })
      threads = threads.filter((item) => {
        const status = this.ignoreStatuses.find(
          (el) => el.id === item.status_id && el.isIgnore
        )
        return !status
      })

      for (const thread of threads) {
        if (colorArr.indexOf(thread.color?.substr(1)) == -1) {
          continue
        }
        if (thread.color === TREADS_POLY_SUBCOLOR.tko && this.ignoreTKOLine) {
          continue
        }
        if (
          thread.color === TREADS_POLY_SUBCOLOR.other &&
          this.ignoreOtherLine
        ) {
          continue
        }
        if (
          thread.color === TREADS_POLY_SUBCOLOR.mixed &&
          this.ignoreMixedLine
        ) {
          continue
        }

        let tko_obj = thread.end

        if (!tko_obj) {
          continue
        }

        thread.status_id = thread.end.status_id

        let relationType = 'settlement-object'
        let showAfterZoom = this.defaultZoom //8
        let endTkoId = thread?.end.id
        let end = Object.assign(thread, {
          type: OBJECT.TKO,
          id: endTkoId,
          name: thread?.name || thread?.end.name,
          lat: thread?.lat || thread?.end.lat,
          lng: thread?.lng || thread?.end.lng,
          power: thread?.end.power,
          showAfterZoom,
        })
        const startType =
          thread.start.type === 'tko_object' ? OBJECT.TKO : OBJECT.CITY
        const start = Object.assign(
          {},
          {
            id: thread.start.id,
            lat: thread.start.lat,
            lng: thread.start.lng,
            type: startType,
            name: thread.start.name,
            showAfterZoom,
          }
        )

        // сообщение показ при наведение на связь
        let relationTooltip = ''
        relationTooltip += `${start.name} —> ${end.name}<br>`
        if (!this.isGuest) {
          if (end.hasOwnProperty('garbage_value')) {
            relationTooltip += this.isBlank(end.garbage_value) + ' т/год '
          } else if (thread.hasOwnProperty('size_tonn')) {
            relationTooltip += thread.size_tonn + ' т/год '
          }

          if (end.hasOwnProperty('garbage_value_cubic')) {
            relationTooltip +=
              this.isBlank(end.garbage_value_cubic) + ' куб.м/год '
          } else if (end.hasOwnProperty('total_cubic')) {
            relationTooltip += this.isBlank(end.total_cubic) + ' куб.м/год '
          }
        }

        let distance = 0
        let distanceInKM = 0

        if (
          !end.is_plan &&
          end.hasOwnProperty('distance') &&
          end.distance > 0
        ) {
          distance = end.distance
          distanceInKM = distance
        } else if (
          end.hasOwnProperty('planning_distance') &&
          end.planning_distance > 0
        ) {
          distance = end.planning_distance
        }

        if (distance && !this.isGuest) {
          distanceInKM = Math.round(distance / 1000)
          relationTooltip += distanceInKM + ' км '
        }

        end.relationTooltip = relationTooltip

        // для процент загрузки объекта нужен
        // power(мощность объекта) и garbage_sum(сумма всех отходов объекта)
        end.power = end.power || null
        end.garbage_sum = end.garbage_sum || null

        // создания индекса с минимальным масштабами
        // для отображения по id объекта
        if (!tkoMinZoom[endTkoId]) {
          tkoMinZoom[endTkoId] = +showAfterZoom
        }

        if (showAfterZoom < tkoMinZoom[endTkoId]) {
          tkoMinZoom[endTkoId] = +showAfterZoom
        }

        nodes.push({ start, end, relationType })
      }
      // обновления значений масштаба исходя из мин значений
      for (let i = 0; i < nodes.length; i++) {
        if (tkoMinZoom[nodes[i].end.id]) {
          nodes[i].end.showAfterZoom = tkoMinZoom[nodes[i].end.id]
        }
        if (nodes[i].relationType === 'object-object') {
          if (tkoMinZoom[nodes[i].start.id]) {
            nodes[i].start.showAfterZoom = tkoMinZoom[nodes[i].start.id]
          }
        }
        if (this.showThreadsAll) {
          nodes[i].end.oldShowAfterZoom = nodes[i].end.showAfterZoom
          nodes[i].end.showAfterZoom = 1
          nodes[i].start.oldShowAfterZoom = nodes[i].start.showAfterZoom
          nodes[i].start.showAfterZoom = 1
        }
      }
      return nodes
    },
    isGuest() {
      return this.$store.getters.isGuest
    },
  },
  methods: {
    defineShowAfterZoom(set) {
      let showAfterZoom = this.defaultZoom

      // population zoom
      // http://redmine.etton.ru/issues/12160
      let zoomDictionary = {
        98000: 1,
        50000: 6,
        10000: 7,
        1000: 8,
        300: 9,
        100: 10,
      }
      if (!set?.population || set?.population === 0) {
        showAfterZoom = this.defaultZoom
      } else {
        for (const population in zoomDictionary) {
          showAfterZoom =
            set?.population > +population
              ? zoomDictionary[population]
              : showAfterZoom
        }
      }

      if (this.showObjectsAll) {
        showAfterZoom = 1
      }
      return showAfterZoom
    },
    isBlank(value) {
      if (!value || value === 0) {
        return (value = ' - ')
      }
      return value
    },
    getMapTkoObjectsEndpoint(route) {
      return mapEndpoints.objectForThreads(route)
    },
    getThreadEndpoint(route) {
      if (!route.query.year) {
        route.query.year = year.getCurrentYear()
      }
      if (!route.query?.flows) {
        route.query.flows = true
      }
      return mapEndpoints.threadsByYear(route)
    },
    getSettlementEndpoint(route) {
      return mapEndpoints.settlements(route)
    },
    getGarbageSourceEndpoint(route) {
      return mapEndpoints.garbageSources(route)
    },
    getUnauthorizedTkosEndpoint(route) {
      return mapEndpoints.unauthorizedObjectForThreads('', route)
    },
    getUnauthorizedHeapsEndpoint(route) {
      return mapEndpoints.heap('', route)
    },
    getMSNContainersEndpoint(route) {
      return mapEndpoints.msn('', route)
    },
    showAll(val) {
      this.$store.commit('preloaderStart')
      setTimeout(() => {
        this.showObjectsAll = val
        this.refreshMap()
        this.$store.commit('preloaderEnd')
      }, 200)
    },
    // показать/скрыть отдельные типы потоков ...
    showHideLine(vals) {
      this.$store.commit('preloaderStart')
      if (vals == null) {
        this.allowThreadTypes = []
      } else {
        vals.forEach((val) => {
          let index = this.allowThreadTypes.indexOf(val)
          if (index == -1) {
            this.allowThreadTypes.push(val)
          } else {
            this.allowThreadTypes.splice(index, 1)
          }
        })
      }

      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },
    showAllThreads(val) {
      this.$store.commit('preloaderStart')
      this.showThreadsAll = val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },
    showModelTariffsHandle(val) {
      this.$store.commit('preloaderStart')
      this.showModelTariffs = val
      setTimeout(() => {
        if (this.showModelTariffs) {
          this.borderDrawer.drawLocality(this.mapTariffs, true)
          if (this.popup_tariff) {
            this.popup_tariff.remove()
          }
          this.popup_tariff = L.popup({
            maxHeight: 700,
            className: 'tooltip tooltip--top',
            bottomOffset: 50,
          })
            .setLatLng(event.latlng)
            .openOn(this.map)
        } else {
          if (this.popup_tariff) {
            this.popup_tariff.remove()
          }
          this.borderDrawer.drawLocality(this.heatMapFormedDistrict, true)
        }
        this.refreshMap()
        this.$store.commit('preloaderEnd')
      }, 200)
    },
    async updateStatus({ type, val }) {
      const status = this.ignoreStatuses.find((item) => item.slug === type)
      status.isIgnore = !val
      const status_ids = this.ignoreStatuses
        .filter((item) => !item.isIgnore)
        .map((item) => item.id)
        .join()
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.threads({
          query: { status_ids, year: year.getCurrentYear(), flows: true },
        }),
        fromCache: false,
      })
      this.$store.commit('mutateEndpoint', {
        endpoint: mapEndpoints.threads(this.$route),
        response: { data: response.data },
      })
      this.refreshMap()
    },
    getQuery() {
      const query = {}
      if (this.fkkoList.length) {
        query.fkko_ids = this.fkkoList.map((item) => item.id).join(',')
        this.replaceRoute({ fkko_ids: query.fkko_ids })
      } else {
        delete query.fkko_ids
        this.replaceRoute({ fkko_ids: null })
      }
      if (this.dangerClasses.length) {
        query.danger_classes = this.dangerClasses.join(',')
        this.replaceRoute({ danger_classes: query.danger_classes })
      } else {
        delete query.danger_classes
        this.replaceRoute({ danger_classes: null })
      }
      let currentYear = year.getCurrentYear()
      if (this.$route.query.year) {
        currentYear = this.$route.query.year
      }
      query.year = currentYear

      return query
    },
    async getMsnRequest() {
      const query = this.getQuery()
      query.flows = true

      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.threads({ query }),
        fromCache: false,
      })
      this.$store.commit('mutateEndpoint', {
        endpoint: mapEndpoints.threads(this.$route),
        response: { data: response.data },
      })
      this.refreshMap()
    },
    getMapPolygon() {
      return REGION_CONFIG.polygon
    },
    // offline remove data
    removeRelationFromStore(relation) {
      let tmp = Object.assign({}, this.threadsRawData)
      tmp.threads.filter((v) => v.id !== relation.thread_id)
      this.$store.commit('setEndpointData', {
        endpoint: this.getThreadEndpoint(this.$route, {}),
        data: tmp,
      })
    },
    afterMapInit() {
      this.objectDrawer = new ObjectDrawer(this.map, this)
    },
    getMapConfigData() {
      return mapConfig
    },
    setView(data) {
      if (this.map) {
        this.map.setView([data.lat, data.lng], data.zoom)
        if (data.refreshMap) {
          this.refreshMap()
        }
      }
    },
    updateMap() {
      if (this.threadsDrawer) {
        let promises = []
        promises.push(
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getThreadEndpoint({
              ...(this.$route?.query?.year && {
                year: this.$route?.query?.year,
              }),
            }),
          })
        )
        // for show tko, after relation del from map
        promises.push(
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getMapTkoObjectsEndpoint(this.$route),
          })
        )

        this.$bar.start()
        Promise.all(promises)
          .then(() => {
            this.refreshMap()
          })
          .finally(() => this.$bar.finish())
      }
    },
    setFiltersFromUrl() {
      let route = url.getRoute(this.$route)

      // TODO: create dynamic search model
      if (route.query.year) {
        this.year = +route.query.year
      } else {
        this.year = year.getCurrentYear()
      }

      this.q = route.query?.q || ''
    },
    refreshMap() {
      this.threadsDrawer && this.threadsDrawer.refreshMap(this.relations)
    },
    routeHandler(newVal, oldVal) {
      this.setFiltersFromUrl()
      if (
        newVal?.query?.layers?.length !== oldVal?.query?.layers?.length ||
        newVal?.query?.year !== oldVal?.query?.year
      ) {
        this.refreshMap()
      }
    },
    setDateToTkoObjects() {
      const dates = ['object_date_start', 'object_date_finish']
      dates.forEach((type) => {
        if (url.getHashParam(type)) {
          this.updateTkoObjects({
            type,
            value: url.getHashParam(type),
          })
        }
      })
    },
    moveendHandler() {
      if (this.map) {
        let latlng = this.map.getCenter()
        this.replaceRoute({
          center: [latlng.lat, latlng.lng],
          optimizeThreads: this.optimizeThreads || null,
        })
      }
    },
    zoomHandler() {
      if (this.map) {
        this.replaceRoute({
          zoom: this.map.getZoom(),
          optimizeThreads: this.optimizeThreads || null,
        })
      }
    },
    /* required for use in map-poup */
    registerClosePopup() {
      this.replaceRoute({ openedPopupInfo: null, lastEventPos: null })
    },
    /* required for use in map-poup */
    registerOpenPopup(marker) {
      if (marker.options.model.type === 'settlement') {
        const id = marker.options.model.id
        this.requestToGeoObject(id)
        this.drawSettlementBorders(id)
      }
      if (marker.options.openedPopupInfo) {
        // lastEventPos - need for register correct relation popup pos
        this.replaceRoute({
          openedPopupInfo: marker.options.openedPopupInfo,
          lastEventPos: marker.options.lastEventPos,
        })
      }
    },
    async requestToGeoObject(geo_object_id) {
      if (this.sourceLayer) {
        this.map.removeLayer(this.sourceLayer)
      }
      this.sourceLayer = L.markerClusterGroup()

      const data = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.source(null, { query: { geo_object_id } }),
        })
      ).data
      const flatObjects = Object.values(data).reduce((item, arr) => {
        item.forEach((el) => {
          if (!arr.find((some) => some.lat === el.lat && some.lng === el.lng)) {
            arr.push(el)
          }
        })
        return arr
      }, [])

      flatObjects.forEach((el) => {
        const marker = L.marker([el.lat, el.lng], {
          icon: MARKER_ICON,
        })
        const popup = L.popup()
        popup.setContent(this.addContentToObject({ name: el.name }))
        marker.bindPopup(popup)
        this.sourceLayer.addLayer(marker)
      })
      this.map.addLayer(this.sourceLayer)
    },
    addContentToObject({ name }) {
      return `<div class='object-popup'>
        <div>${name}</div>
      `
    },
    drawSettlementBorders(id) {
      const thread = this.threads.data.find((item) => item.start.id === id)
      let polygon = thread.start.geo_json
        ? JSON.parse(thread.start.geo_json).coordinates[0]
        : null
      if (!polygon) {
        return
      }
      polygon = polygon.map((item) => {
        return [item[1], item[0]]
      })
      if (this.settlementBorder) {
        this.map.removeLayer(this.settlementBorder)
      }
      this.settlementBorder = L.polygon(polygon, {
        color: COLORS.grey,
        fillOpacity: 0.1,
        weight: 2,
      })
      this.settlementBorder.addTo(this.map)
    },
    getObjectDrawer() {
      return this.objectDrawer
        ? this.objectDrawer
        : new ObjectDrawer(this.map, this)
    },
    setThreadsYears(val) {
      const data = val.data?.data || val.data
      if (data) {
        let dateTkoStarts = data.map((item) => item.end.object_date_start)
        dateTkoStarts = this.adapterTkoYears(dateTkoStarts)

        let dateTkoEnds = data.map((item) => item.end.object_date_finish)
        dateTkoEnds = this.adapterTkoYears(dateTkoEnds)

        if (!this.dateTkoStarts.length) {
          this.dateTkoStarts = dateTkoStarts
        }

        if (!this.dateTkoEnds.length) {
          this.dateTkoEnds = dateTkoEnds
        }
      }
    },
    setObjectStartYears(val) {
      if (!val) {
        return false
      }
      let commonObject = []
      Object.entries(val).forEach(([, value]) => {
        commonObject = [...commonObject, ...value]
      })
      let dateTkoStarts = commonObject.map((item) => item.object_date_start)
      dateTkoStarts = this.adapterTkoYears(dateTkoStarts)

      let dateTkoEnds = commonObject.map((item) => item.object_date_finish)
      dateTkoEnds = this.adapterTkoYears(dateTkoEnds)

      if (!this.dateTkoStarts.length) {
        this.dateTkoStarts = dateTkoStarts
      }

      if (!this.dateTkoEnds.length) {
        this.dateTkoEnds = dateTkoEnds
      }
    },
    changeDateTko({ type, value }) {
      this[type] = value

      this.updateTkoObjects()
      this.refreshMap()
    },
    async updateTkoObjects() {
      let threads = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getThreadEndpoint(this.$route, {}),
          data: threads,
          fromCache: false,
          cache: false,
        })
      ).data.data
      if (this.object_date_start && this.object_date_finish) {
        threads = threads.filter(
          (item) =>
            item.end.object_date_start == this.object_date_start &&
            item.end.object_date_finish == this.object_date_finish
        )
      } else if (this.object_date_start) {
        threads = threads.filter(
          (item) => item.end.object_date_start == this.object_date_start
        )
      } else if (this.object_date_finish) {
        threads = threads.filter(
          (item) => item.end.object_date_finish == this.object_date_finish
        )
      }
      const response = {
        data: threads,
      }
      this.$store.commit('setEndpointData', {
        endpoint: this.getThreadEndpoint(this.$route, {}),
        data: response,
      })
      this.refreshMap()
    },
    adapterTkoYears(years) {
      let dates = years.filter((item) => item !== null).sort((a, b) => a - b)
      dates = Array.from(new Set(dates))
      dates = dates.map((item) => {
        return {
          value: item,
          checked: false,
        }
      })

      return dates
    },
    async geoObjectsById({ apoIds, currentYear }) {
      const getYear =
        currentYear || url.getHashParam('year') || year.getCurrentYear()
      const query = {
        apo_ids: apoIds || '',
        year: getYear,
      }
      this.replaceRoute({ apo_ids: query.apo_ids, year: getYear })
      this.threadsDrawer.removeGeoJsons()
      if (apoIds?.length) {
        const response = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: atu.apoGeoObject({
              query: query,
            }),
            fromCache: false,
          })
        ).data.data
        if (response.length && this.threadsDrawer) {
          response.forEach((item) => {
            const geoJson = JSON.parse(item.geo_json)
            geoJson &&
              this.threadsDrawer.setGeoJson({ ...item, geo_json: geoJson })
          })
        }
      }
    },
  },
}
